import React from 'react';
import './checkbox.scss';
import GeckoFieldBase from '../_base.jsx';

class GeckoFieldCheckbox extends GeckoFieldBase {
  values = this.props.values[this.field().key]
    ? this.props.values[this.field().key]
    : [];

  prepareValue(value) {
    if (this.isChecked(value)) {
      this.values.splice(this.values.indexOf(value), 1);
    } else {
      this.values.push(value);
    }

    return this.values;
  }

  isChecked(value) {
    return this.values.indexOf(value) !== -1;
  }

  renderOption(option, i) {
    return (
      <label onChange={this.handleChange.bind(this)} key={i}>
        <input
          className="gecko-radio"
          type="checkbox"
          value={option.value}
          checked={this.isChecked(option.value)}
          onChange={() => {}}
          disabled={this.isDisabled()}
        />
        <span>{option.label || option.value}</span>
      </label>
    );
  }

  render() {
    return (
      <div>
        {this.options().map((option, i) => {
          return this.renderOption(option, i);
        })}
      </div>
    );
  }
}

export default GeckoFieldCheckbox;
